<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useHeaderAssessmentTemplates } from '../../model/assessments/header-assessment-templates.hook'

defineOptions({
  name: 'HeaderAssessmentTemplates',
})

const {
  config,
} = useHeaderAssessmentTemplates()
</script>

<template>
  <div class="box-assessment-templates-header">
    <NavigationBreadcrumbs :config="config" />
  </div>
</template>

<style scoped lang="scss" src="./HeaderAssessmentTemplates.scss" />
